module.exports = "<router-outlet></router-outlet>\n<div [hidden]=\"!isLoading\" id=\"loaderDiv\">\n    <img class=\"spinner-width\" src=\"assets/images/spinner.gif\">\n</div>\n<missing-capability></missing-capability>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main